import AbstractModel from './AbstractModel'
import Mapper from './mapper/Mapper'
import Column from './table/Column'
import SelectColumn from './table/SelectColumn'

class TabControlli extends AbstractModel {
  permission () {
    return {
      'USR': {
        action: { isInsertable: false, isEditable: true, isDeletable: false },
        columns: {}
      },
      'ADM': {
        action: { isImpersonate: false, isInsertable: true, isEditable: true, isDeletable: true },
        columns: {}
      }
    }
  }
  mapper () {
    return [
      Mapper.column.azienda(true),
      Mapper.column.ambito()
    ]
  }
  columns () {
    return [
      new Column('btn').withHtml(true).withWidth('100px').withIsEditable(false).withIsInsertable(false).withExportable(false),
      new Column('idazi').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new Column('id').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new Column('ordine').withType('text'),
      new Column('dex').withType('text'),
      new Column('valrif').withType('text'),
      new Column('freqgg').withType('number'),
      new SelectColumn('flsett', Mapper.select.daysOfWeek()).withHtmlType('multiselect').withOptions([{ value: 'LUN', label: 'Lunedì' }, { value: 'MAR', label: 'Martedì' }, { value: 'MER', label: 'Mercoledì' }, { value: 'GIO', label: 'Giovedì' }, { value: 'VEN', label: 'Venerdì' }, { value: 'SAB', label: 'Sabato' }, { value: 'DOM', label: 'Domenica' }]).withType('text').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new Column('email').withType('email').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new SelectColumn('ambito', Mapper.select.ambito()).withType('text').withIsVisible(false).withOnEditDisabled(true).withOnInsertDisabled(true)
    ]
  }

  validator () {
    return {
      idazi: { required: true, type: 'number' },
      ambito: { required: true, type: 'string' },
      dexdpi: { required: true, type: 'string' },
      marcamodello: { required: true, type: 'string' },
      mansione: { required: true, type: 'string' },
      fattore: { required: true, type: 'string' }
    }
  }
}

export default new TabControlli()
